import { z } from "zod";
/* Staff-authored operational notes on a customer — the clinic console's
 * Notes tab.
 *
 * What a note is, decided deliberately rather than left to whoever types
 * first (compliance/roadmap.md, `023_patient_notes.sql`): a coordination
 * record. Who was called, what was arranged, what the customer asked for.
 * It is **not** a clinician's assessment of their health — that capability
 * is a stage-1 roadmap row that brings asiakastietolaki's tietojärjestelmä
 * duties with it, and a text box is not how it gets built. The pane says so
 * to the person typing; this schema is what a later widening (a merkintä
 * `kind`, the author's ammattinimike) would extend.
 *
 * Append-only on the wire as well as in the table: there is no update or
 * delete shape here, and there is deliberately no id in the create request.
 * A correction is a new note.
 */
export const patientNoteSchema = z.object({
    id: z.string(),
    /** The staff user who wrote it. Their name as it was at write time —
        snapshotted, not resolved on read (see the migration). Null when no
        verified identity carried one. */
    authorUserId: z.string(),
    authorName: z.string().nullable(),
    body: z.string(),
    createdAt: z.string(),
});
// 4000 chars: long enough for a real handover paragraph, short enough that
// the column is not a dumping ground for a pasted document. Trimmed and
// non-empty, so an accidental whitespace-only save is a 400 rather than a
// blank row in the record.
export const PATIENT_NOTE_MAX_LENGTH = 4000;
export const patientNoteCreateSchema = z.object({
    body: z.string().trim().min(1).max(PATIENT_NOTE_MAX_LENGTH),
});
